import { InputChange } from "../../types";
import ChangeHistoryCardFieldChangeLine from "./FieldChangeLine";
import ChangeHistoryCardSeparator from "./Separator";
import ChangeHistoryCardTimeLabel from "./TimeLabel";

type ChangeHistoryCardSingleInputSummaryProps = {
  change: InputChange;
  timeLabel: string;
};

const ChangeHistoryCardSingleInputSummary = ({
  change,
  timeLabel,
}: ChangeHistoryCardSingleInputSummaryProps) => (
  <>
    <ChangeHistoryCardFieldChangeLine change={change} />
    <ChangeHistoryCardSeparator />
    <ChangeHistoryCardTimeLabel timeLabel={timeLabel} />
  </>
);

export default ChangeHistoryCardSingleInputSummary;
